export const LOADER_STATUS = 'boilderplate/GSTR8_CashBalance/LOADER_STATUS';
